<template>
   <div class="container-fluid bg-light-purple charts-overview-landing">
      <div v-if="contents" class="content">
         <div class="row">
            <div class="col-12">
               <h1 class="mb-1">{{ contents.header }}</h1>
               <div
                  v-if="contents.longDescription"
                  v-html="markedRender(contents.longDescription)"
               />
            </div>
         </div>
         <div class="row">
            <div class="col">
               <div class="card-deck card-deck-special">
                  <div v-for="(item, index) in contents.body" :key="index" class="card">
                     <router-link :to="item.url" class="card-content">
                        <div class="item-container">
                           <div class="item-container-box">
                              <img
                                 v-if="!item.vectorSource && item.rasterSource"
                                 :src="item.rasterSource.file.url"
                                 :alt="item.rasterSource.description"
                                 class="item-container-box-img"
                                 :width="item.rasterSource.file.details.image.width"
                                 :height="item.rasterSource.file.details.image.height"
                              />
                              <img
                                 v-if="item.vectorSource"
                                 :src="item.vectorSource.file.url"
                                 :alt="item.vectorSource.description"
                                 class="item-container-box-img"
                                 :width="item.vectorSource.file.details.image.width"
                                 :height="item.vectorSource.file.details.image.height"
                              />
                           </div>
                           <div class="card-body pt-0 pb-2">
                              <h2 v-if="item.header" class="mb-1 card-title bold">
                                 {{ item.header }}
                              </h2>
                              <p v-if="item.shortDescription" class="card-text">
                                 {{ `${item.shortDescription}` }}
                              </p>
                           </div>
                        </div>
                     </router-link>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <Accordion v-if="faq" :config="faq" />
   </div>
</template>
<script>
import { mapState } from 'vuex';
import metaGenerator from '../../util/meta.js';
import Accordion from '../../components/pricing/Accordion.vue';

export default {
   name: 'ChartsTypeOverview',
   components: {
      Accordion,
   },
   data() {
      return {
         ...(process.browser && { mixpanelChartGalleryTracker: this.$tracker.chartGallery }),
      };
   },
   computed: {
      ...mapState(['overviewChartsTypeData']),
      contents() {
         if (
            this.overviewChartsTypeData &&
            this.overviewChartsTypeData.length &&
            this.overviewChartsTypeData[0].content &&
            this.overviewChartsTypeData[0].content.length
         ) {
            return this.overviewChartsTypeData[0].content[0];
         }
         return null;
      },
      faq() {
         return this.overviewChartsTypeData[0].content[1];
      },
   },
   asyncData({ store, route }) {
      return store.dispatch('CHART_TYPE_OVERVIEW_DATA_FETCH', {
         type: route.params.type,
      });
   },
   created() {
      if (!this.contents) {
         throw Object.assign(new Error(), {
            code: 404,
            message: 'Chart Overview NOT FOUND',
         });
      }
   },
   mounted() {
      this.mixpanelChartGalleryTracker.visited();
   },
   metaInfo() {
      return metaGenerator(this.overviewChartsTypeData[0]);
   },
};
</script>

<style lang="scss" scoped>
@import '../../util';
@import '../../common_scss/img.scss';

.chart-gallery-overview {
   height: 100%;
}

.content {
   padding: 30px 0;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 30px 30px;
   }
   @include media-breakpoint-up(lg) {
      padding: 50px 30px 50px 40px;
   }
}

.charts-overview-landing {
   .card-deck-special {
      margin: 15px -15px;

      .card {
         background: none;
         border-radius: 0;
         margin: 0;
         padding: 10px 15px 20px;
         flex: 0 0 auto;
         min-width: 100%;
         max-width: 100%;

         @media (min-width: 567px) {
            flex: 0 0 auto;
            min-width: 50%;
            max-width: 50%;
         }
         @media (min-width: 1200px) {
            flex: 0 0 auto;
            min-width: 33.33%;
            max-width: 33.33%;
         }
         // @media (min-width: 1440px) {
         //    flex: 0 0 33.33%;
         // }

         .card-text {
            color: #686980;
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 1.3;
         }

         .card-title {
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 20px;
            color: #212344;
         }

         .card-content {
            height: 100%;
            background: #fff;
            border-radius: 5px;
            box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;

            &.explore-maps-content {
               width: auto;
               transition: all 0.2s ease;
               text-decoration: none;
               &:hover {
                  transform: translateY(-4px);
                  transition: all 0.2s ease;
               }
            }
            .explore-maps {
               height: 100%;
               width: auto;
            }
         }

         a.card-content {
            transition: all 0.2s ease;
            text-decoration: none;
            &:hover {
               transform: translateY(-4px);
               transition: all 0.2s ease;
            }
         }

         .card-img-top {
            height: 200px;
            margin: 0 auto;
            display: flex;
            max-width: 350px;
         }

         &.slick {
            .card-header {
               padding: 0;
               height: 100%;
            }
            a {
               display: block;
               padding: 15px 15px 15px 5px;
               h2 {
                  margin: 0;
               }
            }
            .img-container {
               img {
                  height: 55px;
               }
            }
         }
      }
   }
}
</style>
